import React, { useState, useRef, useEffect } from 'react';

const Hero = () => {
  const [showArrow, setShowArrow] = useState(false);
  const [videoReady, setVideoReady] = useState(false);
  const [animateTagline, setAnimateTagline] = useState(false);
  const videoRef = useRef(null);

  // Use direct URL - the video will load progressively
  const videoUrl = "https://customer-assets.emergentagent.com/job_amy-documentary/artifacts/mi51fc88_LOOP.mp4";

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      const handleCanPlay = () => {
        setVideoReady(true);
        video.play().catch(e => console.log('Autoplay blocked:', e));
      };
      
      video.addEventListener('canplay', handleCanPlay);
      return () => video.removeEventListener('canplay', handleCanPlay);
    }
  }, []);

  // Trigger tagline animation after component mounts
  useEffect(() => {
    const taglineTimer = setTimeout(() => setAnimateTagline(true), 500);
    return () => {
      clearTimeout(taglineTimer);
    };
  }, []);

  const handleScrollDown = () => {
    window.scrollTo({
      top: window.innerHeight,
      behavior: 'smooth'
    });
  };

  return (
    <section data-testid="hero-section" className="relative h-screen w-full overflow-hidden" style={{ backgroundColor: '#1a1a1a' }}>
      <div className="absolute inset-0">
        <video
          ref={videoRef}
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover"
          style={{ 
            filter: 'brightness(0.6)',
            opacity: videoReady ? 1 : 0,
            transition: 'opacity 1s ease-in-out'
          }}
        >
          <source src={videoUrl} type="video/mp4" />
        </video>
      </div>

      <div className="absolute inset-0 flex flex-col items-center justify-center px-4" style={{ paddingTop: '15vh', paddingBottom: '15vh' }}>
        <div className="text-center">
          <h1
            data-testid="hero-title"
            className="text-5xl md:text-7xl lg:text-8xl leading-[0.9] uppercase font-bold mb-6 text-cream"
            style={{ fontFamily: 'Anton, sans-serif' }}
          >
            Amy Dyduch
          </h1>
          <p 
            className="text-lg md:text-xl lg:text-2xl text-cream"
            style={{ 
              fontFamily: "'DM Sans', sans-serif",
              opacity: animateTagline ? 1 : 0,
              transform: animateTagline ? 'translateY(0)' : 'translateY(20px)',
              transition: 'opacity 1s ease-out, transform 1s ease-out'
            }}
          >
            Cinematic storytelling rooted in the real
          </p>
        </div>
      </div>

      <div
        className="absolute bottom-12 left-1/2 transform -translate-x-1/2 scroll-indicator flex flex-col items-center gap-2"
        onClick={handleScrollDown}
        onMouseEnter={() => setShowArrow(true)}
        onMouseLeave={() => setShowArrow(false)}
        data-testid="scroll-indicator"
        style={{ cursor: 'pointer' }}
      >
        <p className="text-xs uppercase tracking-widest text-cream" style={{ opacity: 0.7 }}>Scroll Down</p>
        {showArrow && (
          <div className="flex flex-col items-center" data-testid="scroll-arrow" style={{ opacity: 0.4, marginTop: '4px' }}>
            <div className="w-2 h-2 border-r border-b border-cream transform rotate-45"></div>
            <div className="w-2 h-2 border-r border-b border-cream transform rotate-45" style={{ marginTop: '-4px' }}></div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Hero;
